module.exports = __webpack_public_path__ + "static/media/weather.e97041e3.svg";